import { Checkbox } from "@/Components/ui/checkbox"
import React from 'react'
import { AppContext } from "@/App";
import { useIsMobile } from "@/hooks/use-mobile";

// Helper function to get visual preference from localStorage
const getVisualPreference = (key: string, defaultValue: boolean = true): boolean => {
    const saved = localStorage.getItem(key);
    return saved !== null ? saved === 'true' : defaultValue;
};

const UserPreferences = () => {
    const app = React.useContext(AppContext) // get the app context
    const isMobile = useIsMobile();
    const [taskbarNotifications, setTaskbarNotifications] = React.useState(app.applicationUser?.userSettings?.taskbarNotifications);
    const [inlineTableEditing, setInlineTableEditing] = React.useState(app.applicationUser?.userSettings?.inlineTableEditing);
    const [glassmorphismEnabled, setGlassmorphismEnabled] = React.useState(() => 
        getVisualPreference('glassmorphism-enabled')
    );
    const [backgroundPatternEnabled, setBackgroundPatternEnabled] = React.useState(() => 
        getVisualPreference('background-pattern-enabled')
    );

    React.useEffect(() => {
        setTaskbarNotifications(app.applicationUser?.userSettings?.taskbarNotifications);
        setInlineTableEditing(app.applicationUser?.userSettings?.inlineTableEditing);
    }, [app.applicationUser?.userSettings?.taskbarNotifications, app.applicationUser?.userSettings?.inlineTableEditing])

    React.useEffect(() => {
        // Apply or remove glassmorphism class to body
        document.body.setAttribute('data-glassmorphism', glassmorphismEnabled.toString());
        localStorage.setItem('glassmorphism-enabled', glassmorphismEnabled.toString());
    }, [glassmorphismEnabled]);

    React.useEffect(() => {
        // Apply or remove background pattern class to body
        document.body.setAttribute('data-background-pattern', backgroundPatternEnabled.toString());
        localStorage.setItem('background-pattern-enabled', backgroundPatternEnabled.toString());
    }, [backgroundPatternEnabled]);

    function handleNotificationsPreferenceChange(isChecked: boolean) {
        app.updateUserSettings("taskbarNotifications", isChecked.toString());
        setTaskbarNotifications(isChecked);
    }

    function handleInlineTableEditingChange(isChecked: boolean) {
        app.updateUserSettings("inlineTableEditing", isChecked.toString());
        setInlineTableEditing(isChecked);
    }

    function handleGlassmorphismChange(isChecked: boolean) {
        setGlassmorphismEnabled(isChecked);
    }

    function handleBackgroundPatternChange(isChecked: boolean) {
        setBackgroundPatternEnabled(isChecked);
    }

  return (
    <div className={`${isMobile ? "text-2xl " : "w-1/4 mx-auto"} m-2 p-2`}>
        <div className={`justify-between flex flex-row items-center gap-2 mt-4`}>
            <label htmlFor="taskbarNotifications">Use Taskbar Notifications</label>
            <Checkbox
                id="taskbarNotifications"
                checked={taskbarNotifications}
                onCheckedChange={handleNotificationsPreferenceChange}
                className={`${isMobile ? "scale-150 origin-left" : ""}`}
            />
        </div>
        <div className={`justify-between flex flex-row items-center gap-2 mt-4`}>
            <label htmlFor="inlineTableEditing">Enable Inline RAIDS Table Editing</label>
            <Checkbox
                id="inlineTableEditing"
                checked={inlineTableEditing}
                onCheckedChange={handleInlineTableEditingChange}
                className={`${isMobile ? "scale-150 origin-left" : ""}`}
            />
        </div>
        <div className={`justify-between flex flex-row items-center gap-2 mt-4`}>
            <label htmlFor="glassmorphism">Enable Glassmorphism Effect</label>
            <Checkbox
                id="glassmorphism"
                checked={glassmorphismEnabled}
                onCheckedChange={handleGlassmorphismChange}
                className={`${isMobile ? "scale-150 origin-left" : ""}`}
            />
        </div>
        <div className={`justify-between flex flex-row items-center gap-2 mt-4`}>
            <label htmlFor="backgroundPattern">Enable Background Pattern</label>
            <Checkbox
                id="backgroundPattern"
                checked={backgroundPatternEnabled}
                onCheckedChange={handleBackgroundPatternChange}
                className={`${isMobile ? "scale-150 origin-left" : ""}`}
            />
        </div>
    </div>
  )
}

export default UserPreferences